import { Link, useLocation } from "react-router-dom"
import { useSession } from "../contexts/SessionContext"
import { cn } from "@prescreen/lib/utils"
import { UserRole } from "@prescreen/lib/types/user"

const allNavigationItems = [
  { href: "/", label: "Create Integration", roles: ["administrator", "integrator"] },
  { href: "/integrations", label: "Integrations", roles: ["administrator", "integrator"] },
  { href: "/reports", label: "Credit Reports", roles: ["administrator"] },
  { href: "/admin/invitations", label: "Invitations", roles: ["administrator"] },
] as const

export default function TabNavigation() {
  const location = useLocation()
  const { user } = useSession()
  const userRole = user?.role || "integrator"
  
  const navigationItems = allNavigationItems.filter(item => 
    (item.roles as readonly UserRole[]).includes(userRole as UserRole)
  )

  const gridColsClass = navigationItems.length === 2 ? 'grid-cols-2' :
                        navigationItems.length === 3 ? 'grid-cols-3' :
                        navigationItems.length === 4 ? 'grid-cols-4' :
                        navigationItems.length === 5 ? 'grid-cols-5' : 'grid-cols-1'

  return (
    <div className="bg-muted text-muted-foreground inline-flex h-9 w-full items-center justify-center rounded-lg p-[3px]">
      <div className={`grid w-full ${gridColsClass}`}>
        {navigationItems.map((item) => {
          const isActive = item.href === "/" 
            ? location.pathname === "/"
            : location.pathname === item.href || location.pathname.startsWith(item.href + "/")
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring",
                isActive
                  ? "bg-background text-foreground shadow-sm dark:border-input dark:bg-input/30 dark:text-foreground"
                  : "text-foreground dark:text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              )}
            >
              {item.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
